<script lang="ts">import Grid from '../Grid/Grid.svelte';
import Section from '../Section/Section.svelte';
import Text from '../Typography/Text/Text.svelte';
import TextStack from '../TextStack/TextStack.svelte';
const { colorMode = 'light', headingText = '', headingLevel = 'h2', headingSize = 'large', bodySize = 'large', bodyText: bodyTextFromProps, ctaItems: ctaItemsFromProps, children, class: className = '', ...rest } = $props();
const mappedVariant = {
    large: '700',
    small: '600',
};
</script>

<Section {...rest} class="Callout {className}" {colorMode}>
  <Grid class="Callout__container">
    <div class="Callout__heading">
      <Text as={headingLevel} variant={mappedVariant[headingSize ?? 'large']} isBalanced={true}>
        {headingText}
      </Text>
    </div>
    <div class="Callout__body Callout__body--{bodySize}">
      <TextStack ctaLayout="column">
        {#snippet bodyText()}
          {@render bodyTextFromProps?.()}
        {/snippet}
        {#snippet ctaItems()}
          {@render ctaItemsFromProps?.()}
        {/snippet}
      </TextStack>
    </div>
    {@render children?.()}
  </Grid>
</Section>

<style>@layer design-system-components.pwds {
  .Callout__heading {
    grid-column: var(--callout-grid-columns-heading);
  }
  .Callout__body {
    grid-column: var(--callout-grid-columns-body);
  }
  .Callout__body--large :global(p) {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-200-font-size);
    --font-weight: var(--text-variant-200-font-weight);
    --letter-spacing: var(--text-variant-200-letter-spacing);
    --line-height: var(--text-variant-200-line-height);
    --max-width: var(--text-variant-200-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  .Callout__body--small :global(p) {
    --font-family: var(--text-font-family);
    --color: var(--color-text);
    --font-size: var(--text-variant-100-r-font-size);
    --font-weight: var(--text-variant-100-r-font-weight);
    --letter-spacing: var(--text-variant-100-r-letter-spacing);
    --line-height: var(--text-variant-100-r-line-height);
    --max-width: var(--text-variant-100-r-max-width);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    letter-spacing: var(--letter-spacing);
    line-height: var(--line-height);
    max-width: var(--max-width);
  }
  :global(.Callout) :global(.Callout__container) {
    padding-top: var(--callout-container-padding);
    padding-bottom: var(--callout-container-padding);
    background-color: var(--callout-background-color);
  }
}</style>
